import React from 'react';
import PropTypes from 'prop-types';

import { Reason } from 'components/common/charts/charts';
import { PageSubTitle } from 'components/common/Elements/Elements';

const Charts = ({ data }) => {
  return (
    <section>
      <PageSubTitle hiden title="Cancellations chart" />
      <Reason dataChart={data.cancellationReason} />
    </section>
  );
};

Charts.propTypes = {
  data: PropTypes.object
};

export default Charts;
